import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Download Istantaneo', 'Nessun Abbonamento', 'Accesso a Vita', 'Garanzia di 7 Giorni'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-110" data-mp="9ll98xi2jyni">
      <div className="mx-auto max-w-4xl text-center" data-id="element-111" data-mp="4lyw0o28qiep">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[2.15rem] font-black leading-[1.05] tracking-tight text-ink sm:text-5xl md:text-[3.5rem]" data-id="element-112" data-mp="4na06ozlls6c">
          Risolvi un Intero Anno di Allenamenti di Running in soli{' '}
          <span className="italic text-brand" data-id="element-113" data-mp="nboo33emcq2x">5 Minuti</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-114" data-mp="3d2l8d8tzsyz4">
          Unisciti a oltre 1.200 coach e istruttori che hanno smesso di improvvisare. Entra in pista
          con tutto pronto per spiegare, allenare e ispirare.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-115" data-mp="3e8efj63mtg2w">
          <img src="https://cdn.magicpatterns.com/uploads/cE1ACTHeV2WUw73rbp7azJ/f5977d2b-7f31-436e-abfb-11d703ca5994.webp" alt="Il pacchetto RUNNING PRONTO: i sei volumi definitivi per il coaching professionale con programmi tecnici, schede di forza e mobilità, strategie di gara e i 5 bonus strategici inclusi" className="mx-auto w-[72%] max-w-md sm:w-[66%]" data-id="element-116" data-mp="2qkmu9d045sph" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mt-2 sm:mt-8" data-id="element-117" data-mp="s2jmbumnjwig">
          <CtaButton href="#offer" data-id="element-118" data-mp="ichxh0mh6a2h" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-119" data-mp="ddf4wfnolwbe">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-120" data-mp="1ayt710s27lbf" data-mpi={index}>
                <span data-id="element-121" data-mp="16344qponnqbf">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-122" data-mp="1126o4hjan4c1">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}